export default "__VITE_ASSET__6herLjiD__"